<template>
  <div>
    <button
      v-on:click="downloadAnexo()"
      href="javascript:void(0)"
      class="btn btn-primary"
    >
      Preventivas
    </button>
   </div>
</template>

<script>
export default {
  data () {
    return {
      env: process.env,
      planilha: []
    }
  },
  methods: {
    downloadAnexo: function () {
      let grupo = ''
      if (localStorage.getItem('sessaoUsuario')) {
        let sessaoUsuario = JSON.parse(localStorage.getItem('sessaoUsuario'))
        grupo = (sessaoUsuario.grupo.nome)
      } else {
        vm.$store.commit('setAlert', {msg: 'Ocorreu um erro ao recuperar as definições de segurança. Se persistir favor avisar ao Suporte SSP.', status: false, show: true})
        return
      }
      let vm = this
      let dados = ''
      if (grupo === 'adminVTAL') {
        dados = {
          'dirBucket': 'aplicacao-ssp-planilhas-desenvolvimento',
          'nomeArquivo': 'predial-operacional/grupo1/vtal/preventivas.csv'
        }
      } else {
        dados = {
          'dirBucket': 'aplicacao-ssp-planilhas-desenvolvimento',
          'nomeArquivo': 'predial-operacional/grupo1/preventivas.csv'
        }
      }
      this.$axios.post(`${this.env.FINANCEIRO.SLA}/getPlanilhasExternas`, dados, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      }).then(function (response) {
        if (response.data.mensagem) {
          vm.$store.commit('setAlert', {msg: response.data.mensagem, status: false, show: true})
          return
        }
        window.open(response.data.url, '_blank')
      })
      // window.open(`${this.env.FINANCEIRO.SLA}/downloadExport/preventivas`, '_blank')
      // let vm = this
      // this.$axios.post(`${this.env.FINANCEIRO.SLA}/getPlanilhaExport/preventivas`, {
      //   headers: {
      //     'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
      //   }
      // }).then(function (response) {
      //   if (response.data.mensagem) {
      //     vm.$store.commit('setAlert', {msg: response.data.mensagem, status: false, show: true})
      //     return
      //   }
      //   window.open(response.data.url, '_blank')
      // })
    }
  }
}
</script>

<style scoped>
  button:hover {
    background-color: #6c757d;
  }
  /* button {
    background-color:#3c7fe4;
    color: white;
    margin: 1%;
    padding-left:15px;
    padding-right:15px;
    padding-bottom:5px;
    padding-top:5px;
    border-style: none;
    border-radius: 5px;
    width: 160px;
    height: 50px;
    word-break: break-all
  } */
</style>



// WEBPACK FOOTER //
// ExportPreventivas.vue?338b64cb